function openBookeroForm() {
 let buttonBookeroChoose = document.querySelectorAll('.choose-method');
 let bookeroChangeMethod = document.querySelector('.change-method');
 let callMeNowContainer = document.querySelector('.content-form-extra');
 let yourMethodBanner = document.querySelector('.choose-your-method');
 let dataMethod;
 let dataMethodID;
 if (buttonBookeroChoose.length > 0) {
  buttonBookeroChoose.forEach(button => {
   button.addEventListener('click', (e) => {
    e.preventDefault();

    buttonBookeroChoose.forEach(element => {
     element.style.display = 'none';
    });

    dataMethod = button.getAttribute('data-method');
    yourMethodBanner.style.display = 'block';
    yourMethodBanner.querySelector('span').innerHTML = dataMethod;

    callMeNowContainer.style.display = 'none';
    bookeroChangeMethod.style.display = 'block';

    dataMethodID = button.getAttribute('data-method-id');
    if (dataMethodID === 'phone') {
     console.log('phone');
     let script = document.createElement('script');
     innerHtml = `
     var bookero_config = {
      id: 'JRJDVwSavlIK',
      container: 'bookero-10680',
      type: 'calendar',
      position: '',
      plugin_css: true,
      lang: 'pl',
      override: {
        scroll_after_add_to_cart_selector: '#section-10680'
      },
      custom_config: {
       use_service_id: 22819
      }
    };
    (function () {
      var d = document, s = d.createElement('script');
      s.src = 'https://cdn.bookero.pl/plugin/v2/js/bookero-compiled.js';
      d.body.appendChild(s);
    })();`
     script.innerHTML = innerHtml;
     document.body.appendChild(script);
    } else if (dataMethodID === 'video') {
     console.log('video');
     let script = document.createElement('script');
     innerHtml = `
     var bookero_config = {
      id: 'JRJDVwSavlIK',
      container: 'bookero-10680',
      type: 'calendar',
      position: '',
      plugin_css: true,
      lang: 'pl',
      override: {
        scroll_after_add_to_cart_selector: '#section-10680'
      },
      custom_config: {
       use_service_id: 36765
      }
     };
     (function () {
       var d = document, s = d.createElement('script');
       s.src = 'https://cdn.bookero.pl/plugin/v2/js/bookero-compiled.js';
       d.body.appendChild(s);
     })();`
     script.innerHTML = innerHtml;
     document.body.appendChild(script);
    }
   });
  });
 }

 if (bookeroChangeMethod !== null) {
  bookeroChangeMethod.addEventListener('click', (e) => {
   e.preventDefault();
   window.location.reload();
  });
 }

 if (callMeNowContainer !== null) {
  let callMeNowButton = callMeNowContainer.querySelector('button');
  callMeNowButton.addEventListener('click', (e) => {
   e.preventDefault();
   callMeNowContainer.classList.toggle('active')
  })
 }
}
openBookeroForm()